import { useSelectedProductDataVersion } from '@upright/ui/common/upright/model/output/releases/hooks';
import { useModelVersionAvailability } from '@upright/ui/api/model/versions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ImpactSizeFactorByImpactCodeAndValence } from '../../../../../common/model/input/impact-size-factors/types';
import { noopCallback, useGetData } from '../../../../api/common/hooks';
import { RequestStatus } from '../../../../api/common/types';
import { fetchImpactSizeFactors } from '../../../../api/model/input/impact-size-factors';
import { storeImpactSizeFactors } from '../../../../untidy/redux/actions/actions';

/**
 * Triggers storing impact size factors into redux state with the following logic:
 * - if a release is selected, load size factors corresponding to default product data of that release
 * - if a release is not selected, load size factors corresponding to selected product data version
 */
export function useLoadImpactSizeFactors() {
  const version = useSelectedProductDataVersion();

  // In non-production environments the database only holds a subset of versions, so
  // skip the fetch when the resolved version isn't loaded here — it would only 400.
  const { isUnavailableInThisEnvironment } = useModelVersionAvailability(version);

  const { data, requestStatus, ok } = useGetData<ImpactSizeFactorByImpactCodeAndValence>(
    version && !isUnavailableInThisEnvironment ? async () => await fetchImpactSizeFactors(version) : noopCallback,
    [version, isUnavailableInThisEnvironment],
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (requestStatus === RequestStatus.SUCCESS && ok && data) {
      dispatch(storeImpactSizeFactors(data));
    } else if (!ok) {
      dispatch(storeImpactSizeFactors(undefined));
    }
  }, [data]);
  return data;
}
